var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.357,
    height: 17.124,
    viewBox: "0 0 23.357 17.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M1504.93-707.615a4.17,4.17,0,0,1,0,5.769c-2.21,2.137-5.653,4.678-9.52,4.678s-7.31-2.541-9.52-4.678a4.17,4.17,0,0,1,0-5.769c2.21-2.136,5.653-4.678,9.52-4.678S1502.719-709.752,1504.93-707.615Z",
    transform: "translate(-1484.731 712.293)",
    fill: "none",
    stroke: "#08070d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4911",
    "data-name": "Ellipse 4911",
    cx: 3.324,
    cy: 3.324,
    r: 3.324,
    transform: "translate(7.355 4.238)",
    fill: "none",
    stroke: "#08070d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.5f67a41a0a1fc0244b8a2fcb424a8dfd.svg";
export { ForwardRef as ReactComponent };